import React from 'react'
import { Container, Row } from 'react-bootstrap'

import { graphql, useStaticQuery } from 'gatsby'
import BoxCliente from './../BoxCliente'
import ItemCliente from '../ItemProductosCliente'


const Productos = ({ id, executeScroll }) => {
    const { info: { productosCliente: productos } } = useStaticQuery(getData);

    return (
        <>
            <section className="page-section bg-tipocliente" >
                <div id={id} className="name-section">
                    <Container >
                        <h1 className="text-center mt-0 title-general text-white anim-2s" data-sal="slide-down" >Tenemos <span className="letra-cian">las mejores</span> <br /> <span className="letra-cian">soluciones</span> para tu negocio<span className="letra-cian">_</span> </h1>
                        <br /><br />
                        <Row>
                            {
                                productos.map((item, index) => <BoxCliente key={index} data={item} />)
                            }
                        </Row>

                    </Container >
                </div>
            </section>
            <section className="page-section" >
                {
                    productos.map((item, index) => <ItemCliente key={index} data={item} executeScroll={executeScroll} />)
                }

            </section >
        </>
    )
}

export default Productos

const getData = graphql`
    {
        info:dataJson {
            productosCliente {
            tipo
            descripcion
            imagen
            posicion
            productos {
                descripcion
                marca
                link
            }
            }
        }

    }
`







